import { LANG_COOKIE } from '../../constants.js';

const createCookieDetection = (cfg) => (request) => {
    const localeCookieValue = request.cookies.get(LANG_COOKIE.name)?.value;
    if (cfg.availableLanguageTags.includes(localeCookieValue))
        return localeCookieValue;
    else
        return undefined;
};

export { createCookieDetection };
